import { DRDoc, EODoc } from '../maintenance/types';

export type DBFile = {
    id: number;
    name: string;
    type: FileType;
    checksum: string;
    fileSize: number;
    objectKey: string;
    meta: Record<string, any>;
    createdAt: Date;
    updatedAt: Date;
};

export type FileWithLinks = DBFile & {
    numRowsIngested: number | null;
    numRowsFailed: number | null;
    metaIngested: Record<string, any>;
    presignedUrl: string;
};

export enum IngestionType {
    ticket = 'ticket',
    docs = 'docs',
    layover = 'layover',
    air = 'air',
    mpd = 'mpd',
    eo = 'eo',
    sb = 'sb',
    ad = 'ad',
    wo = 'wo',
    tc = 'tc',
    nrms = 'nrms',
    dir = 'dir',
    ril = 'ril',
    ct = 'ct',
    ur = 'ur',
    ldnd = 'ldnd',
    adtlb = 'adtlb',
    sv = 'sv',
    amp = 'amp',
    lptr = 'lptr',
}

export type DBIngestedFile = {
    id: number;
    teamId: number;
    fileId: number;
    ingestionType: IngestionType;
    leasingProjectId?: number;
    uniqueId: string;
    meta: Record<string, any>;
    annotations: Record<string, any>;
    createdAt: Date;
    updatedAt: Date;
};

export type FileStats = DBIngestedFile & {
    name: string;
    type: FileType;
    fileSize: number;
};

export type DocsPreview = {
    eoDoc: EODoc | null;
    drDoc: DRDoc | null;
};

export enum FileType {
    sb = 'sb',
    sbsr = 'sbsr',
    ad = 'ad',
    adsr = 'adsr',
    contract = 'contract',
    eo = 'eo',
    dr = 'dr',
    ticket = 'ticket',
    layover = 'layover',
    mpd = 'mpd',
    sr = 'sr',
    cmm = 'cmm',
    arc = 'arc',
    wo = 'wo',
    air = 'air',
    tc = 'tc',
    nrms = 'nrms',
    dir = 'dir',
    ril = 'ril',
    ct = 'ct',
    rdas = 'rdas',
    wr = 'wr',
    ur = 'ur',
    ldnd = 'ldnd',
    adtlb = 'adtlb',
    sv = 'sv',
    afm = 'afm',
    amp = 'amp',
    lptr = 'lptr',
}

export const FILE_TYPES = [
    { value: FileType.sb, label: 'Service Bulletin' },
    { value: FileType.sbsr, label: 'Service Bulletin Status Report' },
    { value: FileType.ad, label: 'Airworthiness Directives' },
    { value: FileType.adsr, label: 'Airworthiness Directive Status Report' },
    { value: FileType.contract, label: 'Contracts' },
    { value: FileType.eo, label: 'Engineering Order' },
    { value: FileType.dr, label: 'Damage Reports' },
    { value: FileType.ticket, label: 'Tickets' },
    { value: FileType.layover, label: 'Layover' },
    { value: FileType.mpd, label: 'Maintenance Planning Document' },
    { value: FileType.sr, label: 'Status Report' },
    { value: FileType.cmm, label: 'Component Maintenance Manual' },
    { value: FileType.arc, label: 'Authorized Release Certificate' },
    { value: FileType.wo, label: 'Work Order' },
    { value: FileType.air, label: 'Aircraft Inspection Report' },
    { value: FileType.tc, label: 'Task Card' },
    { value: FileType.nrms, label: 'Non-Routine Maintenance Sheet' },
    { value: FileType.dir, label: 'Discrepancy Report' },
    { value: FileType.ril, label: 'Removal/Installation List' },
    { value: FileType.ct, label: 'Component Tag' },
    { value: FileType.rdas, label: 'Repair Design Approval Sheet' },
    { value: FileType.wr, label: 'Work Report' },
    { value: FileType.ur, label: 'Utilization Report' },
    { value: FileType.ldnd, label: 'Last Done / Next Due' },
    { value: FileType.adtlb, label: 'Aircraft Delivery Technical Logbook' },
    { value: FileType.sv, label: 'Shop Visit Report' },
    { value: FileType.afm, label: 'Aircraft Flight Manual' },
    { value: FileType.amp, label: 'Aircraft Maintenance Program' },
    { value: FileType.lptr, label: 'Life Preserver Teardown Report' },
];
